/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import SubscriptionLanguageModel from 'cio/models/subscription-language';
import SubscriptionTopicModel from 'cio/models/subscription-topic';
import { MAX_NAME_LENGTH, MAX_DESCRIPTION_LENGTH } from 'cio/utils/subscription-center';
import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';

interface SubscriptionCenterLocalizationEditTranslationArgs {
  language: SubscriptionLanguageModel;
  topic: SubscriptionTopicModel;
  isEditing: boolean;
  showErrors: boolean;
  onNameChange: (name: string) => unknown;
  onDescriptionChange: (description: string) => unknown;
}

export default class SubscriptionCenterLocalizationEditTranslation extends Component<SubscriptionCenterLocalizationEditTranslationArgs> {
  get missingName() {
    return isEmpty(this.args.language.topicsById[this.args.topic.id]?.name);
  }

  get missingDescription() {
    return isEmpty(this.args.language.topicsById[this.args.topic.id]?.description);
  }

  get name() {
    return this.args.language.topicsById[this.args.topic.id]?.name ?? '';
  }

  get description() {
    return this.args.language.topicsById[this.args.topic.id]?.description ?? '';
  }

  get nameErrors() {
    if (!this.args.showErrors) {
      return [];
    }

    if (this.args.language.enabled && this.name.length === 0) {
      return ['Name is required'];
    }

    if (this.name.length > MAX_NAME_LENGTH) {
      return [`Name can't be longer than ${MAX_NAME_LENGTH} characters`];
    }

    return [];
  }

  get descriptionErrors() {
    if (!this.args.showErrors || isEmpty(this.args.topic.description)) {
      return [];
    }

    if (this.args.language.enabled && this.description.length === 0) {
      return ['Description is required'];
    }

    if (this.description.length > MAX_DESCRIPTION_LENGTH) {
      return [`Description can't be longer than ${MAX_DESCRIPTION_LENGTH} characters`];
    }

    return [];
  }

  @action
  onDescriptionChange(evt: FlyKeyboardEvent<HTMLTextAreaElement>) {
    this.args.onDescriptionChange(evt.target.value);
  }
}
